import type { IPagingInfo } from "@frui.ts/data";
import { serializeFilters } from "../utils/filters";
import RepositoryBase from "./repositoryBase";
import type BackOfficeConnector from "../data/backOfficeConnector";
import type EventBus from "../services/eventBus";
import RejectedCustomerRefundCandidateResponse from "../entities/rejectedCustomerRefundCandidateResponse";
import RejectedCustomerRefundCandidateDetailResponse from "../entities/rejectedCustomerRefundCandidateDetailResponse";
import type RejectedCustomerRefundCandidateSearchRequest from "../entities/rejectedCustomerRefundCandidateSearchRequest";

export default class RejectedCustomerRefundCandidatesRepository extends RepositoryBase<BackOfficeConnector> {
  constructor(protected apiFactory: ReturnType<typeof BackOfficeConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }

  getAll(paging: IPagingInfo, filters: RejectedCustomerRefundCandidateSearchRequest) {
    return this.callApi(api =>
      api
        .all("finance")
        .all("rejected_customer_refund_candidate_search")
        .postPagedEntities(serializeFilters({ ...filters, ...paging }, false), RejectedCustomerRefundCandidateResponse)
    );
  }

  get(candidateId: string) {
    return this.callApi(api =>
      api
        .all("finance")
        .one("rejected_customer_refund_candidates", candidateId)
        .getEntity(RejectedCustomerRefundCandidateDetailResponse)
    );
  }

  recreations(candidateId: string) {
    return this.callApi(api =>
      api.all("finance").one("rejected_customer_refund_candidates", candidateId).all("recreations").postOnly({})
    );
  }
}
